<template>
  <footer class="text-white bg-gray-900">
    <div class="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">
        <div class="space-y-8 xl:col-span-1">
          <img class="w-auto h-10" src="@/assets/logo-branco.png" alt="Kali Sistemas" width="394" height="138" />
          <p class="text-base text-gray-400">
            Soluções completas em sistemas de gestão para sua empresa crescer.
          </p>
          <div class="flex items-center space-x-6 min-h-[24px]">
            <a v-for="link in socialLinks" :key="link.network" :href="link.url" :aria-label="link.label"
              class="text-gray-400 transition-colors hover:text-gray-300" target="_blank" rel="noopener noreferrer">
              <span class="sr-only">{{ link.label }}</span>
              <svg v-if="link.network === 'facebook'" class="w-6 h-6" fill="currentColor" viewBox="0 0 320 512"
                aria-hidden="true">
                <path
                  d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
              </svg>
              <svg v-else-if="link.network === 'instagram'" class="w-6 h-6" fill="currentColor" viewBox="0 0 16 16"
                aria-hidden="true">
                <path
                  d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
              </svg>
              <svg v-else-if="link.network === 'linkedin'" class="w-6 h-6" fill="currentColor" viewBox="0 0 448 512"
                aria-hidden="true">
                <path
                  d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
              </svg>
              <svg v-else-if="link.network === 'youtube'" class="w-6 h-6" fill="currentColor" viewBox="0 0 16 16"
                aria-hidden="true">
                <path
                  d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
              </svg>
              <svg v-else-if="link.network === 'tiktok'" class="w-6 h-6" fill="currentColor" viewBox="0 0 16 16"
                aria-hidden="true">
                <path
                  d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z" />
              </svg>
            </a>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-8 mt-12 xl:mt-0 xl:col-span-2">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h3 class="text-sm font-semibold tracking-wider text-gray-300 uppercase">
                Soluções
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="/solucao/kali-gestao" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Gestão
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-agro" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Agro
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-food" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Food
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-clinica" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Clínica
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-salao" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Salão
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-studio" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Studio
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-pet" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Pet
                  </a>
                </li>
                <li>
                  <a href="/solucao/kali-shop" class="text-base text-gray-400 hover:text-gray-300">
                    Kali Shop
                  </a>
                </li>
                <li>
                  <a href="/certificado-digital" class="text-base text-gray-400 hover:text-gray-300">
                    Certificado Digital
                  </a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h3 class="text-sm font-semibold tracking-wider text-gray-300 uppercase">
                Empresa
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="/sobre-nos" class="text-base text-gray-400 hover:text-gray-300">
                    Sobre nós
                  </a>
                </li>
                <li>
                  <a href="/blog" class="text-base text-gray-400 hover:text-gray-300">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="/parceiros-e-integracoes" class="text-base text-gray-400 hover:text-gray-300">
                    Parceiros
                  </a>
                </li>
                <li>
                  <a href="/carreiras" class="text-base text-gray-400 hover:text-gray-300">
                    Carreiras
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h3 class="text-sm font-semibold tracking-wider text-gray-300 uppercase">
                Suporte
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="/ajuda" class="text-base text-gray-400 hover:text-gray-300">
                    Central de Ajuda
                  </a>
                </li>
                <li>
                  <a href="/documentacao" class="text-base text-gray-400 hover:text-gray-300">
                    Documentação
                  </a>
                </li>
                <li>
                  <a href="/status" class="text-base text-gray-400 hover:text-gray-300">
                    Status
                  </a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h3 class="text-sm font-semibold tracking-wider text-gray-300 uppercase">
                Legal
              </h3>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="/politica-de-privacidade" class="text-base text-gray-400 hover:text-gray-300">
                    Política de Privacidade
                  </a>
                </li>
                <li>
                  <a href="/politica-de-cookies" class="text-base text-gray-400 hover:text-gray-300">
                    Política de Cookies
                  </a>
                </li>
                <li>
                  <a href="/termos-de-uso" class="text-base text-gray-400 hover:text-gray-300">
                    Termos de Uso
                  </a>
                </li>
                <li>
                  <a href="/meus-dados" class="text-base text-gray-400 hover:text-gray-300">
                    Meus Dados (LGPD)
                  </a>
                </li>
                <li>
                  <button type="button" @click="manageCookies"
                    class="text-base text-gray-400 hover:text-gray-300 text-left">
                    Gerenciar Cookies
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-8 mt-12 border-t border-gray-700">
        <p class="text-base text-left text-gray-400">
          &copy; {{ new Date().getFullYear() }} Kali Sistemas. Todos os direitos
          reservados.
        </p>
        <p class="mt-1 text-sm text-left text-gray-400">
          CNPJ: 55.252.075/0001-51
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "SiteFooter",
};
</script>

<script setup>
import { ref, onMounted } from 'vue'
import api from '@/services/api'

const socialLinks = ref([])

onMounted(async () => {
  if (import.meta.env.SSR) return
  try {
    const { data } = await api.get('/public/social-links')
    socialLinks.value = Array.isArray(data) ? data : []
  } catch {
    // links sociais são opcionais — footer funciona normalmente sem eles
  }
})

// Reabre o banner de cookies pra o usuário revisar/mudar a decisão a qualquer momento.
function manageCookies() {
  if (typeof window !== 'undefined' && window.kaliResetCookieConsent) {
    window.kaliResetCookieConsent()
  }
}
</script>
